var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgConnecting = function SvgConnecting(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "eShOf25FeWn1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 150 150",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#eShOf25FeWn25)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#eShOf25FeWn23)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    mask: "url(#eShOf25FeWn10)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "eShOf25FeWn7_tr",
    transform: "translate(75.000151,75) rotate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-75.000151,-75)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M75,30.208c-24.7375,0-44.7917,20.0542-44.7917,44.7917s20.0542,44.7913,44.7917,44.7913s44.792-20.0538,44.792-44.7913-20.0545-44.7917-44.792-44.7917Z",
    fill: "none",
    stroke: "#edf2fd",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.162,57.311c2.337,5.4264,3.63,11.407,3.63,17.6889c0,24.7375-20.0545,44.7921-44.792,44.7921s-44.7917-20.0546-44.7917-44.7921c0-.9541.0292-1.9014.0889-2.8416",
    fill: "none",
    stroke: "#6a57c7",
    strokeWidth: 6,
    strokeLinecap: "round"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "eShOf25FeWn10",
    "mask-type": "luminance",
    x: "-150%",
    y: "-150%",
    height: "400%",
    width: "400%"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M150,0L0,0v150h150v-150Z",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#eShOf25FeWn21)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    mask: "url(#eShOf25FeWn19)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "eShOf25FeWn16_ts",
    transform: "translate(94.554298,75.680153) scale(0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "eShOf25FeWn16",
    d: "M94.5541,68.9707c3.7029,0,6.7099,3.0065,6.7099,6.7094c0,3.703-3.007,6.7095-6.7099,6.7095-3.703,0-6.7095-3.0065-6.7095-6.7095c0-3.7029,3.0065-6.7094,6.7095-6.7094Z",
    transform: "translate(-94.554298,-75.680153)",
    opacity: 0.4,
    fill: "#6a57c7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "eShOf25FeWn17_ts",
    transform: "translate(74.392902,75.680401) scale(0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "eShOf25FeWn17",
    d: "M74.3929,68.75c3.8249,0,6.9304,3.1055,6.9304,6.9304s-3.1055,6.9304-6.9304,6.9304-6.9304-3.1055-6.9304-6.9304s3.1055-6.9304,6.9304-6.9304Z",
    transform: "translate(-74.392902,-75.680401)",
    opacity: 0.4,
    fill: "#6a57c7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "eShOf25FeWn18_ts",
    transform: "translate(54.23175,75.68045) scale(0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "eShOf25FeWn18",
    d: "M54.2317,68.9487c3.7153,0,6.7318,3.0165,6.7318,6.7318s-3.0165,6.7317-6.7318,6.7317c-3.7152,0-6.7317-3.0165-6.7317-6.7317s3.0165-6.7318,6.7317-6.7318Z",
    transform: "translate(-54.23175,-75.68045)",
    opacity: 0.4,
    fill: "#6a57c7"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "eShOf25FeWn19",
    "mask-type": "luminance",
    x: "-150%",
    y: "-150%",
    height: "400%",
    width: "400%"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M112,38h-75v75h75v-75Z",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("clipPath", {
    id: "eShOf25FeWn21"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 75,
    height: 75,
    rx: 0,
    ry: 0,
    transform: "translate(37 38)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("clipPath", {
    id: "eShOf25FeWn23"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 150,
    height: 150,
    rx: 0,
    ry: 0,
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("clipPath", {
    id: "eShOf25FeWn25"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 150,
    height: 150,
    rx: 0,
    ry: 0,
    fill: "#fff"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgConnecting);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/connecting.a5554146a3909809d40416fa8dd34dae.svg";